import { axios } from "@Root/API";

export const deleteStudiesStudyProgrammeNote = note_id => {
  return axios.delete(`attache/note/${note_id}/student-course-session`);
};
